import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          React App Roger Created and Deployed via CloudFlare CLI to CloudFlare Pages *for free* :)
        </p>
        
      </header>
    </div>
  );
}

export default App;
